import { SpacingTokens, token } from 'odyssey';
import { ToNumber } from 'shared-types';
import styled from 'styled-components';

export type StackDirection = 'vertical' | 'horizontal';
export type StackGap = SpacingTokens extends `space-${infer space}` ? ToNumber<space> : never;

export type FlexProps = {
  justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'baseline' | 'stretch';
  flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  flexGrow?: number;
  flexShrink?: number;
  flexBasis?: string | number;
};

export const Container = styled.div<{ direction: StackDirection; gap: StackGap } & FlexProps>`
  display: flex;
  flex-direction: ${({ direction }) => (direction === 'vertical' ? 'column' : 'row')};
  gap: ${({ gap }) => token(`space-${gap}`)};
  justify-content: ${({ justifyContent }) => justifyContent || 'flex-start'};
  align-items: ${({ alignItems }) => alignItems || 'stretch'};
  flex-wrap: ${({ flexWrap }) => flexWrap || 'nowrap'};
  flex-grow: ${({ flexGrow }) => flexGrow || 0};
  flex-shrink: ${({ flexShrink }) => flexShrink || 1};
  flex-basis: ${({ flexBasis }) => flexBasis || 'auto'};
`;
